import BaseModel from "../BaseModel";
import Sample from "@/Store/ORM/Sample";
import SampleFlagType from "@/Store/ORM/SampleFlagType";

export default class SampleFlag extends BaseModel {
	static entity = 'sampleFlags';
	static primaryKey = "uuid";
	
	static fields() {
		return {
			uuid: this.attr(null),
			sample_uuid: this.attr(null),
			sample_flag_type_uuid: this.attr(null),
			flag: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			sample: this.belongsTo(Sample, 'sample_uuid'),
			flag_type: this.belongsTo(SampleFlagType, "sample_flag_type_uuid")
		}
	}
	static ignoredLogFields(){
		return ['created_at', 'updated_at']
	}
	
	static name(){
		return "SampleFlags"
	}
	
	static route(){
		return process.env.VUE_APP_RECORDED_API + '/sampleFlags';
	}
	
	static apiConfig = {
		...super.apiConfig,
		headers: {
			"Accept": "application/json",
			"Authorization": process.env.VUE_APP_RECORDED_API_KEY,
			"VueRoute": window.location.href,
		}
	}
}
